import { USERS } from '../../firebase';
import FormUIOptions from '../components/formBuilder/formElements/formUIOptions';

export default {
  layoutClasses: 'max-w-3xl mx-auto py-10 px-4 sm:px-6 lg:py-12 lg:px-8',
  pathToSource: [
    {
      type: 'collection',
      value: USERS,
    },
    {
      type: 'user',
      value: 'uid',
    },
  ],
  inputs: {
    title: 'Profile',
    description: 'Adjust your profile information, plan & payment methods.',
    doNotReset: true,
    schema: [
      {
        sectionLabel: 'Account Basics',
        sectionNoToggle: true,
        sectionValue: 'contactDetails',
        sectionDescription: '',
        sectionClasses: '',
        schema: [
          {
            type: FormUIOptions.Text,
            label: 'Name',
            name: 'userName',
            placeholder: 'Enter your name',
            groupEnd: true,
          },
          {
            type: FormUIOptions.Email,
            label: 'Email',
            name: 'email',
            disabled: true,
            placeholder: 'Enter your email',
            groupEnd: true,
          },
          {
            type: FormUIOptions.Text,
            label: 'Company Name',
            name: 'companyName',
            placeholder: 'Enter your company name',
            groupEnd: true,
          },
          {
            type: FormUIOptions.Place,
            label: 'Company Address',
            layout: 'default',
            name: 'companyAddress',
            placeholder: 'Enter your company address',
          },
        ],
      },
    ],
  },
};
